<template>
    <div class="bslip-item lotto-item" v-if="tickets.length">
        <div class="bslip-lotto-top">
            <div class="bslip-loto-top-left">
                <p class="loto-name">{{lotto.eventName}}</p>
                <div class="bslip-selected-draws">
                    <div class="bslip-draw"
                    v-for="tick in tickets"
                    :key="tick.eventId">
                        <div class="draw-number">
                            <i class="iconset icon-delete"
                            v-if="tickets.length > 1"
                            @click="$emit('deleteticket', tick.id)"></i>
                            <p>{{$t('DRAWNUMBER') + ' ' + tick.id}}</p>
                        </div>
                        <div>
                            <p>{{$formatTicketMatchDate(tick)}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bslip-lotto-bottom">
            <div class="bslip-loto-balls" ref_testcafe="drawnNumbersContainer">
                <div v-for="num in nums" class="loto-number-box" :key="num">
                    <div v-on:click="selectEvent(num);" class="loto-big-num small is-selected selectionPulse">
                        <div class="loto-ball-shadow"></div>
                        <div class="loto-big-num-inner small" ref_testcafe="drawn_number">{{num}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    mapActions,
    mapGetters,
} from 'vuex';

export default {
    name: 'TicketLottoItem',
    props:
    [
        'tickets',
        'ticketItems',
    ],
    methods: {
        ...mapActions([
            'selectBetslipOutcome',
        ]),
        selectEvent(num)
        {
            const me = this;

            for (const item of me.betslip.items)
            {
                if (num === item.meta.selectedBall)
                {
                    me.selectBetslipOutcome(item);
                    return;
                }
            }
        },
    },
    computed:
    {
        ...mapGetters([
            'betslip',
        ]),
        lotto()
        {
            if (this.ticketItems
            && this.ticketItems.length)
            {
                return this.ticketItems[0];
            }

            return {};
        },
        nums()
        {
            const me = this;
            const nums = [];
            for (let i = 0; i < me.ticketItems.length; i += 1)
            {
                const tempItem = me.ticketItems[i];

                nums.push(tempItem.meta.selectedBall);
            }

            return nums;
        },
    },
};
</script>
